import script from "./search-filter.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-filter.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__